import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { JobseekerSigninComponent } from './jobseeker-signin/jobseeker-signin.component';
import { JobseekerProfileComponent } from './jobseeker-profile/jobseeker-profile.component';
import { TestDashboardComponent } from '../hr-ui/test-dashboard/test-dashboard.component';
import { JobseekerRegistrationComponent } from './jobseeker-registration/jobseeker-registration.component';
import { JobseekerRegistrationCompleteComponent } from './jobseeker-registration-complete/jobseeker-registration-complete.component';
//import { JobseekerEmailVerificationComponent } from './jobseeker-email-verification/jobseeker-email-verification.component';
import { JobseekerSettingsComponent } from './jobseeker-settings/jobseeker-settings.component';
import { JobseekerShellComponent } from './jobseeker-shell/jobseeker-shell.component';
import { AuthGuard } from '../core/auth.guard';
import { ViewJobseekerSubscriptionComponent } from './view-jobseeker-subscription/view-jobseeker-subscription.component';
import { EditJobseekerSubscriptionComponent } from './edit-jobseeker-subscription/edit-jobseeker-subscription.component';
import { JobseekerPasswordResetComponent } from './jobseeker-password-reset/jobseeker-password-reset.component';
import { JobseekerAppliesComponent } from './jobseeker-applies/jobseeker-applies.component';
import { JobseekerUnsubscribeCompleteComponent } from './jobseeker-unsubscribe-complete/jobseeker-unsubscribe-complete.component';
import { JobseekerInvitesComponent } from './jobseeker-invites/jobseeker-invites.component';
import { JobseekerInviteListComponent } from './jobseeker-invite-list/jobseeker-invite-list.component';
import { JobseekerInviteDetailsComponent } from './jobseeker-invite-details/jobseeker-invite-details.component';



const jobseekerRoutes: Routes = [
  // {
  //   path: 'action/activate/:code',
  //   pathMatch: 'full',
  //   component: JobseekerEmailVerificationComponent
  // },
  {
      path: '',
      component: JobseekerShellComponent,

      children:[
        {
          path: 'sign-in',
          pathMatch: 'full',
          component: JobseekerSigninComponent,
        },
        {
          path: 'profile',
          pathMatch: 'full',
          component: JobseekerProfileComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'register',
          pathMatch: 'full',
          component: JobseekerRegistrationComponent
        },
        {
          path: 'registration-complete',
          pathMatch: 'full',
          component: JobseekerRegistrationCompleteComponent
        },
        {
          path: 'ui-test',
          pathMatch: 'full',
          component: TestDashboardComponent
        },
        {
          path: 'settings',
          pathMatch: 'full',
          component: JobseekerSettingsComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'reset-password',
          pathMatch: 'full',
          component: JobseekerPasswordResetComponent
        },
        {
          path: 'subscription',
          pathMatch: 'full',
          component: ViewJobseekerSubscriptionComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'subscription/cancelled',
          pathMatch: 'full',
          component: JobseekerUnsubscribeCompleteComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'subscription/edit',
          pathMatch: 'full',
          component: EditJobseekerSubscriptionComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'applies',
          component: JobseekerAppliesComponent,
          canActivate: [AuthGuard],
          children: [
            {
              path: 'invitations',
              component: JobseekerInvitesComponent,
              children: [
                {
                  path: '',
                  pathMatch: 'full',
                  component: JobseekerInviteListComponent,
                },
                {
                  path: ':announcementId',
                  component: JobseekerInviteDetailsComponent,
                },
              ],
            },
          ],
        },
      ]
  }
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(jobseekerRoutes)],
  exports: [RouterModule],
})
export class JobseekerRoutingModule { }
